// extracted by mini-css-extract-plugin
module.exports = {"serviceButton":"Pill_serviceButton__2HuDE","checkIconReplacement":"Pill_checkIconReplacement__2j3eN","disabled":"Pill_disabled__1A0EK"};